import React, { useState } from 'react';
import ReactPlayer from 'react-player';

import { ReactComponent as VideoOutline } from '../../images/backgrounds/multicolor-gradient-bold.svg';
import { CustomModal } from '../BrandCampaign/BrandCampaignHero';
import ContentfulImage from '../Common/ContentfulImage';
import SmartLink from '../Common/SmartLink';
import { AutoPauseVideo } from '../Generic/AutoPauseVideo';
import HeadingCtas from '../Generic/HeadingCtas';
import PageSection from '../PageSections/PageSection';
import * as styles from './StylizedHeadlineHeader.module.scss';

export default function StylizedHeadlineHeader({ fields }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const isModalVideo = fields.videoUrl && fields.imageLink?.toLowerCase() === '#play';

  let bgColor;
  switch (fields.backgroundColor) {
    case 'evergreen deep': {
      bgColor = styles.evergreenDeep;
      break;
    }
    default: {
      bgColor = '';
      break;
    }
  }

  const heroImage = (
    <>
      {fields.headingImageBackground && (
        <ContentfulImage imageFragment={fields.headingImageBackground} fetchpriority={'high'} />
      )}
      {fields.headingImage && <ContentfulImage imageFragment={fields.headingImage} fetchpriority={'high'} />}
    </>
  );

  return (
    <PageSection
      isTopSection
      className={[styles.stylizedHeadlineHeader, bgColor].join(' ')}
      innerClassName={styles.columns}
      data-analytics-section={'stylized-headline-header'}
    >
      <div className={styles.content}>
        <ContentfulImage
          imageFragment={fields.stylizedHeading}
          className={styles.stylizedHeading}
          style={{ translate: `${fields.headlineLeftOffset}%` }}
          fetchpriority={'high'}
        />
        {fields.subheadline && <h3>{fields.subheadline}</h3>}
        <h1>{fields.introCopy}</h1>
        {fields.headingCtAs && <HeadingCtas ctas={fields.headingCtAs} className={styles.ctas} />}
      </div>
      {fields.videoUrl && !isModalVideo && (
        <div className={styles.videoWrapper}>
          <VideoOutline className={styles.videoOutline} />
          <AutoPauseVideo src={fields.videoUrl} classes={[styles.video]} />
        </div>
      )}
      {isModalVideo && (
        <div style={{ cursor: 'pointer' }} onClick={handleOpen}>
          {heroImage}
        </div>
      )}
      {fields.imageLink && !isModalVideo && (
        <SmartLink to={fields.imageLink} className={styles.headingImage}>
          {heroImage}
        </SmartLink>
      )}
      {!fields.imageLink && !isModalVideo && <div className={styles.headingImage}>{heroImage}</div>}
      <CustomModal open={open} onClose={handleClose}>
        <div data-analytics-component={'brand-video-modal'}>
          <ReactPlayer
            url={fields.videoUrl}
            playing={open}
            controls={false}
            width="100%"
            height="360px"
            aria-label={fields.introCopy ? `Video: ${fields.introCopy}` : 'Video player'}
            title={fields.introCopy ? `Video: ${fields.introCopy}` : 'Video player'}
          />
        </div>
      </CustomModal>
    </PageSection>
  );
}
